import Cookies from 'js-cookie';
import ENVIRONMENT from '@/env';

import * as ga from '@/utils/analytics';

// Set cookie
export function setCookie(name, value) {
  Cookies.set(name, value, { expires: 365 });
}

// Get cookie by name
export function getCookie(name) {
  let cookie = Cookies.get(name);
  if (cookie === undefined) {
    return false;
  }
  return cookie;
}

//  Remove cookie by name
export function removeCookie(name) {
  Cookies.remove(name, { path: '/' });
}

//  Remove all cookies by name
export function removeAllCookies() {
  let cookies = document.cookie.split('; ');

  cookies = cookies.map((item) => item.split('=')[0]);
  cookies.forEach((item) => this.removeCookie(item));
}

//  Control cookies
export function setGaCookies(status) {
  window[`ga-disable-${ENVIRONMENT.analytics}`] = status;

  if (!status) {
    ga.init(status);
  }
}

//  Create Linkedin cookies
export function setInCookies() {
  let s = document.getElementsByTagName('script')[0];
  let b = document.createElement('script');
  b.type = 'text/javascript'; b.async = true;
  b.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
  s.parentNode.insertBefore(b, s);
}



// WEBPACK FOOTER //
// src/utils/cookies.js